import { render, staticRenderFns } from "./KLolLeagues.vue?vue&type=template&id=d9eedfa0&scoped=true&"
import script from "./KLolLeagues.vue?vue&type=script&lang=ts&"
export * from "./KLolLeagues.vue?vue&type=script&lang=ts&"
import style0 from "./KLolLeagues.vue?vue&type=style&index=0&id=d9eedfa0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9eedfa0",
  null
  
)

export default component.exports